import loading from './src/Loading.vue'

export default loading
